import { Injectable } from '@angular/core';
import {NGXLogger} from 'ngx-logger';

@Injectable({
  providedIn: 'root',
})
export class ListeService{

  constructor(
   private logger: NGXLogger

    ) {}
    public categorieKOPF:{value: string, label: string}[] = 
    [
      {
        label: "Problema Tripletta OF",
        value: "1"
      },
      {
        label: "Problema Permuta PCN",
        value: "2"
      },
      {
        label: "Problema Centrale OLT",
        value: "3"
      },
      {
        label: "Problema Fibra Fibercop",
        value: "4"
      },
      {
        label: "Problema Fibra OF",
        value: "5"
      },
      {
        label: "Problema Fibra Infratel",
        value: "6"
      },
      {
        label: "Problema Altro",
        value: "7"
      },
      {
        label: "Cassetto Ottico Assente",
        value: "8"
      },
      {
        label: "Causa Cliente",
        value: "9"
      },
  ];

    protected opzioniStatoFlowdyFase1:{value: string, label: string}[] = [
      {
        label: "DA ASSEGNARE",
        value: "DA ASSEGNARE"
      },
      {
        label: "IN ATTESA ODA",
        value: "IN ATTESA ODA"
      },
     {
        label: "ASSEGNATA",
        value: "ASSEGNATA"
      },
      {
        label: "SOPRALLUOGO PIANIFICATO",
        value: "SOPRALLUOGO PIANIFICATO"
      },
      {
        label: "SOPRALLUOGO EFFETTUATO",
        value: "SOPRALLUOGO EFFETTUATO"
      },
      {
        label: "PREVENTIVO IN ATTESA",
        value: "PREVENTIVO IN ATTESA"
      },
      {
        label: "PREVENTIVO RIFIUTATO",
        value: "PREVENTIVO RIFIUTATO"
      },
      {
        label: "PREVENTIVO APPROVATO",
        value: "PREVENTIVO APPROVATO"
      },
      
     {
        label: "SOPRALLUOGO KO",
        value: "SOPRALLUOGO KO"
      },
      {
        label: "CONSEGNATA",
        value: "CONSEGNATA"
      },
      {
        label: "IN VERIFICA SMARTFIBER",
        value: "IN VERIFICA SMARTFIBER"
      },
      {
        label: "IN REWORK AZIENDA",
        value: "IN REWORK AZIENDA"
      },
      {
        label: "IN CARICO PRESIDIO",
        value: "IN CARICO PRESIDIO"
      },
      {
        label: "PUBBLICATA",
        value: "PUBBLICATA"
      },
      {
        label: "APPROVATA",
        value: "APPROVATA"
      },
      {
        label: "RESPINTA",
        value: "RESPINTA"
      },
    ];

    public statiFlowdyFase1:{value: string, label: string}[] = [
      {
        label: "DA ASSEGNARE",
        value: "DA ASSEGNARE"
      },
      {
        label: "IN ATTESA ODA",
        value: "IN ATTESA ODA"
      },
     {
        label: "ASSEGNATA",
        value: "ASSEGNATA"
      },
      {
        label: "SOPRALLUOGO EFFETTUATO",
        value: "SOPRALLUOGO EFFETTUATO"
      },
      {
        label: "PREVENTIVO IN ATTESA",
        value: "PREVENTIVO IN ATTESA"
      },
      {
        label: "PREVENTIVO RIFIUTATO",
        value: "PREVENTIVO RIFIUTATO"
      },
      {
        label: "PREVENTIVO APPROVATO",
        value: "PREVENTIVO APPROVATO"
      },
      {
        label: "PREVENTIVO APPROVATO",
        value: "PREVENTIVO APPROVATO"
      },
     {
        label: "SOPRALLUOGO KO",
        value: "SOPRALLUOGO KO"
      },
      {
        label: "CONSEGNATA",
        value: "CONSEGNATA"
      },
      {
        label: "IN VERIFICA SMARTFIBER",
        value: "IN VERIFICA SMARTFIBER"
      },
      {
        label: "IN REWORK AZIENDA",
        value: "IN REWORK AZIENDA"
      },
      {
        label: "IN CARICO PRESIDIO",
        value: "IN CARICO PRESIDIO"
      },
      {
        label: "PUBBLICATA",
        value: "PUBBLICATA"
      },
      {
        label: "APPROVATA",
        value: "APPROVATA"
      },
      {
        label: "RESPINTA",
        value: "RESPINTA"
      },
    ];

    public statiFlowdyFase1Order = [
      'IN ATTESA ODA',
      'DA ASSEGNARE',
      'ASSEGNATA',
      'SOPRALLUOGO EFFETTUATO',
      'PREVENTIVO IN ATTESA',
      'PREVENTIVO RIFIUTATO',
      'PREVENTIVO APPROVATO',
      'SOPRALLUOGO KO',
      'CONSEGNATA',
      'IN VERIFICA SMARTFIBER',
      'IN REWORK AZIENDA',
      'IN CARICO PRESIDIO',
      'PUBBLICATA',
      'APPROVATA'
    ];

    protected opzioniStatoFlowdyFase2:{value: string, label: string}[] = [
      {
        label: "DA ASSEGNARE",
        value: "DA ASSEGNARE"
      },
     {
        label: "ASSEGNATA",
        value: "ASSEGNATA"
      },
     {
        label: "APPUNTAMENTO FISSATO",
        value: "APPUNTAMENTO FISSATO"
      },
      {
        label: "APPUNTAMENTO MANCATO",
        value: "APPUNTAMENTO MANCATO"
      },
     {
        label: "INSTALLAZIONE EFFETTUATA",
        value: "INSTALLAZIONE EFFETTUATA"
      },
     {
        label: "ATTIVAZIONE KO CPE",
        value: "ATTIVAZIONE KO CPE"
      },
      {
        label: "ATTIVAZIONE KO FO",
        value: "ATTIVAZIONE KO FO"
      },
      {
        label: "CONSEGNATA",
        value: "CONSEGNATA"
      },
      {
        label: "IN VERIFICA SMARTFIBER",
        value: "IN VERIFICA SMARTFIBER"
      },
      {
        label: "IN REWORK AZIENDA",
        value: "IN REWORK AZIENDA"
      },
      {
        label: "IN ATTESA CONFERMA TIM SUPPORT",
        value: "IN ATTESA CONFERMA TIM SUPPORT"
      },
      {
        label: "CONTROLLO TIM SUPPORT KO",
        value: "CONTROLLO TIM SUPPORT KO"
      },
      {
        label: "CONTROLLO TIM SUPPORT OK",
        value: "CONTROLLO TIM SUPPORT OK"
      },
      {
        label: "IN CARICO PRESIDIO",
        value: "IN CARICO PRESIDIO"
      },
      {
        label: "PUBBLICATA",
        value: "PUBBLICATA"
      },
      {
        label: "APPROVATA",
        value: "APPROVATA"
      },
      {
        label: "RESPINTA",
        value: "RESPINTA"
      },
    ];
    protected opzioniStatoFlowdyFase3:{value: string, label: string}[] = [
      {
        label: "IN ATTESA ODA",
        value: "IN ATTESA ODA"
      },
      {
        label: "DA ASSEGNARE",
        value: "DA ASSEGNARE"
      },
     {
        label: "ASSEGNATA",
        value: "ASSEGNATA"
      },
     {
        label: "IN PROGETTAZIONE",
        value: "IN PROGETTAZIONE"
      },
      {
        label: "CONSEGNATA",
        value: "CONSEGNATA"
      },
      {
        label: "IN VERIFICA SMARTFIBER",
        value: "IN VERIFICA SMARTFIBER"
      },
      {
        label: "IN REWORK AZIENDA",
        value: "IN REWORK AZIENDA"
      },
      {
        label: "IN CARICO PRESIDIO",
        value: "IN CARICO PRESIDIO"
      },
      {
        label: "IN FIRMA VERBALE",
        value: "IN FIRMA VERBALE"
      },
      {
        label: "VERBALE FIRMATO",
        value: "VERBALE FIRMATO"
      },
      {
        label: "FIRMATA",
        value: "FIRMATA"
      },
      {
        label: "PUBBLICATA",
        value: "PUBBLICATA"
      },
      {
        label: "APPROVATA",
        value: "APPROVATA"
      },
      {
        label: "RESPINTA",
        value: "RESPINTA"
      },
    ];

    protected opzioniStatoInfratelFase1:{value: string, label: string}[] = [
      {
        label: "1-1",
        value: "1-1"
      },
      {
        label: "1-2",
        value: "1-2"
      },
      {
        label: "1-3",
        value: "1-3"
      },
      {
        label: "1-4",
        value: "1-4"
      },
      {
        label: "1-5",
        value: "1-5"
      },
      {
        label: "1-6",
        value: "1-6"
      },
    ];
    protected opzioniStatoInfratelFase2:{value: string, label: string}[] = [
      {
        label: "2-1",
        value: "2-1"
      },
      {
        label: "2-2",
        value: "2-2"
      },
      {
        label: "2-3",
        value: "2-3"
      },
      {
        label: "2-4",
        value: "2-4"
      },
      {
        label: "2-5",
        value: "2-5"
      },
      {
        label: "2-6",
        value: "2-6"
      },
    ];
    protected opzioniStatoInfratelFase3:{value: string, label: string}[] = [
      {
        label: "3-1",
        value: "3-1"
      },
      {
        label: "3-2",
        value: "3-2"
      },
      {
        label: "3-3",
        value: "3-3"
      },
      {
        label: "3-4",
        value: "3-4"
      },
      {
        label: "3-5",
        value: "3-5"
      },
      {
        label: "3-6",
        value: "3-6"
      },
    ];

    opzioniRegioneProntofibra: { value: string, label: string }[] = [
      { label: "Abruzzo", value: "Abruzzo" },
      { label: "Calabria", value: "Calabria" },
      { label: "Campania", value: "Campania" },
      { label: "Lazio", value: "Lazio" },
      { label: "Liguria", value: "Liguria" },
      { label: "Marche", value: "Marche" },
      { label: "Molise", value: "Molise" },
      { label: "Piemonte", value: "Piemonte" },
      { label: "Puglia", value: "Puglia" },
      { label: "Sardegna", value: "Sardegna" },
      { label: "Sicilia", value: "Sicilia" },
      { label: "Toscana", value: "Toscana" },
      { label: "Valle d'Aosta", value: "Valle d'Aosta" },
      { label: "Veneto", value: "Veneto" }
    ];

    opzioniTipoProntofibra:{value: string, label: string}[] = [
      {
        label: "A",
        value: "A"
      },
      {
        label: "B",
        value: "B"
      },
      {
        label: "B*",
        value: "B*"
      },
      {
        label: "B**",
        value: "B**"
      },
      {
        label: "C",
        value: "C"
      },
      {
        label: "D",
        value: "D"
      },
      {
        label: "Mandatoria A",
        value: "Mandatoria A"
      },
      {
        label: "Mandatoria B",
        value: "Mandatoria B"
      },
      {
        label: "Mandatoria C",
        value: "Mandatoria C"
      },
      {
        label: "Mandatoria D",
        value: "Mandatoria D"
      },
      {
        label: "Aggiuntiva A",
        value: "Aggiuntiva A"
      },
      {
        label: "Aggiuntiva B",
        value: "Aggiuntiva B"
      },
      {
        label: "Aggiuntiva C",
        value: "Aggiuntiva C"
      },
      {
        label: "Aggiuntiva D",
        value: "Aggiuntiva D"
      }
    ];
    opzioniTipoSedeBando1:{value: string, label: string}[] = [
     
     
      {
        label: "Aggiuntiva A",
        value: "Aggiuntiva A"
      },
      {
        label: "Aggiuntiva B",
        value: "Aggiuntiva B"
      },
      {
        label: "Aggiuntiva C",
        value: "Aggiuntiva C"
      },
      {
        label: "Aggiuntiva D",
        value: "Aggiuntiva D"
      },
    
      {
        label: "Mandatoria A",
        value: "Mandatoria A"
      },
      {
        label: "Mandatoria B",
        value: "Mandatoria B"
      },
     
      {
        label: "Mandatoria C",
        value: "Mandatoria C"
      },
      {
        label: "Mandatoria D",
        value: "Mandatoria D"
      }
     
    ];

    opzioniTipoSedeBando2:{id: number, value: string, label: string}[] = [
      {
        id: 1,
        label: "A",
        value: "A"
      },
      {
        id: 2,
        label: "A*",
        value: "A*"
      },
      {
        id: 3,
        label: "B",
        value: "B"
      },
      {
        id: 4,
        label: "B*",
        value: "B*"
      },
      {
        id: 8,
        label: "B**",
        value: "B**"
      },
      {
        id: 5,
        label: "C",
        value: "C"
      },
      {
        id: 6,
        label: "Cy",
        value: "Cy"
      },
      {
        id: 7,
        label: "D",
        value: "D"
      }
    ];


    opzioniBando:{value: string, label: string}[] = [
      {
        label: "BANDO 1",
        value: "BANDO 1"
      },
      {
        label: "BANDO 2",
        value: "BANDO 2"
      }
    ];

    opzioniStatoPF:{value: string, label: string}[] = [
      {
        label: "IN ATTESA",
        value: "IN ATTESA"
      },
      {
        label: "KO",
        value: "KO"
      },
      {
        label: "PRONTO",
        value: "PRONTO"
      },
      {
        label: "ROUTER INSTALLATO",
        value: "ROUTER INSTALLATO"
      },
      {
        label: "SEDE ATTIVATA",
        value: "SEDE ATTIVATA"
      }
    ];

    protected opzioniRegioniBando1:{value: string, label: string}[] = [
      {
        label: "Abruzzo",
        value: "Abruzzo"
      },
      {
        label: "Marche",
        value: "Marche"
      },
      {
        label: "Molise",
        value: "Molise"
      },
      {
        label: "Puglia",
        value: "Puglia"
      },
      {
        label: "Toscana",
        value: "Toscana"
      },
      {
        label: "Veneto",
        value: "Veneto"
      }
    ];


    protected opzioniRegioniBando2:{value: string, label: string}[] = [
      {
        label: "Calabria",
        value: "Calabria"
      },
      {
        label: "Campania",
        value: "Campania"
      },
      {
        label: "Lazio",
        value: "Lazio"
      },
      {
        label: "Liguria",
        value: "Liguria"
      },
      {
        label: "Piemonte",
        value: "Piemonte"
      },
      {
        label: "Sardegna",
        value: "Sardegna"
      },
      {
        label: "Sicilia",
        value: "Sicilia"
      },
      {
        label: "Toscana",
        value: "Toscana"
      }
      ,
      {
        label: "Valle d'Aosta",
        value: "Valle d'Aosta"
      }
    ];

    public tipologieVincolo:{value: number, label: string}[] = [
      {
        label: "1. SOSPESA CON VINCOLO TIM/FC",
        value: 1
      },
      {
        label: "2. SOSPESA CON VINCOLO OF",
        value: 2
      },
      {
        label: "3. SOSPESA IN VALUTAZIONE INFRATEL",
        value: 3
      },
      {
        label: "4. ANNULATA FUORI PERIMETRO",
        value: 4
      }
    ];

    public fasiVincolo:{value: number, label: number}[] = [
      {
        label: 0,
        value: 0
      },
      {
        label: 1,
        value: 1
      },
      {
        label: 2,
        value: 2
      },
      {
        label: 3,
        value: 3
      }
    ];

    protected opzioniCausaKO:{value: string, label: string}[] = [];

    public setOpzioniCausaKO(opzioni: {value: string, label: string}[]) {
      this.opzioniCausaKO = opzioni;
    }

    public getOpzioniCausaKO(): {value: string, label: string}[] {
      return this.opzioniCausaKO;
    }

    protected opzioniVincoloKO:{value: string, label: string}[] = [
      {
        label: "Vincolata Fibercop",
        value: "Vincolata Fibercop",
      },
      {
        label: "Vincolata Ristrutturazione",
        value: "Vincolata Ristrutturazione",
      },
      {
        label: "Vincolata Dimensionamento",
        value: "Vincolata Dimensionamento",
      },
      {
        label: "Vincolata Tipo A",
        value: "Vincolata Tipo A",
      },
      {
        label: "Vincolata Tipo C",
        value: "Vincolata Tipo C",
      },
      {
        label: "Vincolata Dismissione",
        value: "Vincolata Dismissione",
      },
      {
        label: "Vincolata Mancanza Alunni",
        value: "Vincolata Mancanza Alunni",
      },
      {
        label: "Vincolata Permesso",
        value: "Vincolata Permesso",
      },
      {
        label: "Vincolata Manca Adesione",
        value: "Vincolata Manca Adesione",
      },
      {
        label: "Altro",
        value: "Altro"
      },
   
    ];
  
}
